export const HTMLSanitizer = (texto: string) =>
  texto ?  texto.replace('<br/>', ' ') : null;
